import type { ImacTypesEnum } from '~/types/imac.enum';

export const IMAC_SLIDES: { id: number; type: keyof typeof ImacTypesEnum; image: string }[] = [
  {
    id: 1,
    type: 'golden',
    image: '/images/screens/screen-create-prescription.png',
  },
  {
    id: 2,
    type: 'golden',
    image: '/images/screens/screen-prescription-check.png',
  },
  {
    id: 3,
    type: 'golden',
    image: '/images/screens/screen-prescription-detail.png',
  },
  {
    id: 4,
    type: 'golden',
    image: '/images/screens/screen-prescription-overview.png',
  },
];
